// Bestandsnamen van exports — één plek, zodat ze niet per pagina uit elkaar lopen.
//
// Vorm:  <tijdstempel>_<energielabel>[-team][-verkoper]_<basis>.<ext>
// bv.    20260807_2145_Servolt Energie-HOA Team-Jan Janssens_partnervergoeding-orders.csv
//
// Het energielabel staat meteen achter de tijdstempel en niet achteraan: in een map
// met exports van meerdere labels wil je op naam kunnen sorteren en de labels bij
// elkaar zien staan. Verkoopteam en verkoper horen daar direct achter: ze verfijnen
// datzelfde label, en zo blijven exports van dezelfde scope bij elkaar staan i.p.v.
// verspreid te raken over de basisnaam. De basis (waar het bestand over gaat) komt
// dus als laatste, vóór de extensie.

// Tekens die Windows/macOS niet in een bestandsnaam toelaten eruit, en dubbele
// spaties opruimen. Nooit lege stukken laten staan: die geven "__" of "--".
export const veiligeNaamdeel = (v) => String(v ?? '')
  .replace(/[\\/:*?"<>|]+/g, ' ')
  .replace(/\s+/g, ' ')
  .trim();

// Het scope-deel achter het label: '' als er niets gekozen is, anders '-Team' of
// '-Team-Verkoper'.
export function exportScopeStaart(delen = []) {
  const schoon = delen.map(veiligeNaamdeel).filter(Boolean);
  return schoon.length ? `-${schoon.join('-')}` : '';
}

// Het label-deel dat direct achter de tijdstempel komt. Zonder label (of bij
// 'alle') blijft het leesbaar: "…_alle_…".
export function exportLabelDeel(label) {
  const schoon = veiligeNaamdeel(label);
  return schoon || 'alle';
}

// Zet de volledige naam samen. `stamp` eindigt al op '_' (zie exportTimestamp).
// `scope` is de uitkomst van exportScopeStaart en begint dus zelf al met '-'.
export function exportBestandsnaam({ stamp = '', label = '', basis = 'export', scope = '', ext = 'csv' }) {
  return `${stamp}${exportLabelDeel(label)}${scope}_${veiligeNaamdeel(basis)}.${ext}`;
}
